/* r18kaart: gift card page. Live card (amount, name, message), 3D tilt, flip, recipient mode, and one /cart/add.js call.
   Without JavaScript the form is a plain POST to /cart/add and the card goes to the buyer (recipient fields are ignored by Shopify without the flag). */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
    var card = $('[data-ck-card]'), stage = $('[data-ck-stage]'), flipBtn = $('[data-ck-flip]');
    var form = $('[data-ck-form]');
    if (card) {
      if (flipBtn) flipBtn.hidden = false;
      var flipped = false;
      var setFlip = function (v) {
        flipped = v;
        card.classList.toggle('is-flipped', v);
        if (flipBtn) { flipBtn.setAttribute('aria-pressed', v ? 'true' : 'false'); flipBtn.textContent = v ? (root.getAttribute('data-ck-flip-back-label') || '') : (root.getAttribute('data-ck-flip-label') || ''); }
      };
      if (flipBtn) flipBtn.addEventListener('click', function () { setFlip(!flipped); });
      card.addEventListener('click', function () { setFlip(!flipped); });
      // Tilt follows a mouse or pen; a finger does not tilt (it taps to flip). Reduced motion: no transform is ever set.
      if (stage && !reduce) {
        var rest = 0;
        stage.addEventListener('pointermove', function (e) {
          if (e.pointerType === 'touch') return;
          var r = stage.getBoundingClientRect();
          var x = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - 0.5) * 2));
          var y = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - 0.5) * 2));
          card.classList.add('is-tracking');
          card.style.setProperty('--tx', x.toFixed(3));
          card.style.setProperty('--ty', y.toFixed(3));
          card.querySelectorAll('.tt-ck__face').forEach(function (f) { f.style.setProperty('--tx', x.toFixed(3)); f.style.setProperty('--ty', y.toFixed(3)); });
        });
        stage.addEventListener('pointerleave', function () {
          card.classList.remove('is-tracking');
          card.style.setProperty('--tx', rest); card.style.setProperty('--ty', rest);
          card.querySelectorAll('.tt-ck__face').forEach(function (f) { f.style.setProperty('--tx', rest); f.style.setProperty('--ty', rest); });
        });
      }
    }
    if (!form) return;

    var amounts = $$('[data-ck-amount]'), sum = $('[data-ck-sum]');
    var forEl = $('[data-ck-for]'), msgEl = $('[data-ck-msg]'), fromEl = $('[data-ck-from]');
    var name = $('[data-ck-name]'), mail = $('[data-ck-mail]'), message = $('[data-ck-message]'), van = $('[data-ck-van]'), date = $('[data-ck-date]');
    var flag = $('[data-ck-flag]'), offset = $('[data-ck-offset]'), fields = $('[data-ck-fields]'), modes = $('[data-ck-modes]'), selfHint = $('[data-ck-selfhint]');
    var count = $('[data-ck-count]'), err = $('[data-ck-error]'), btn = $('[data-ck-submit]');
    var gift = true, busy = false;

    function showAmount() {
      var r = form.querySelector('input[name="id"]:checked');
      if (!r) return;
      amounts.forEach(function (el) { el.textContent = r.getAttribute('data-ck-price'); });
      if (sum) sum.textContent = ' ' + (root.getAttribute('data-ck-sum-prefix') || '') + ' ' + r.getAttribute('data-ck-price');
    }
    function fill(el, text) {
      if (!el) return;
      var t = (text || '').trim();
      el.textContent = t || el.getAttribute('data-empty') || '';
      el.classList.toggle('is-filled', !!t);
    }
    function showText() {
      var n = gift && name ? name.value.trim() : '';
      fill(forEl, n ? (root.getAttribute('data-ck-for-prefix') || '') + ' ' + n : '');
      fill(msgEl, gift && message ? message.value : '');
      if (fromEl) {
        var v = van && gift ? van.value.trim() : '';
        fromEl.hidden = !v;
        fromEl.textContent = v ? (root.getAttribute('data-ck-from-prefix') || '') + ' ' + v : '';
      }
      if (count && message) count.textContent = (root.getAttribute('data-ck-count-tpl') || '').replace('[n]', message.value.length).replace('[max]', message.maxLength);
    }
    function setMode(g) {
      gift = g;
      if (fields) fields.hidden = !g;
      if (selfHint) selfHint.hidden = g;
      if (flag) flag.disabled = !g;
      if (offset) { offset.disabled = !g; offset.value = String(new Date().getTimezoneOffset()); }
      [name, mail, message, date].forEach(function (el) { if (el) el.disabled = !g; });
      showText();
      hideError();
    }
    function showError(text, field) {
      if (!err) return;
      err.textContent = text; err.hidden = false;
      if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
    }
    function hideError() {
      if (err) { err.hidden = true; err.textContent = ''; }
      if (mail) mail.removeAttribute('aria-invalid');
    }

    // JS is on: show the two-way choice, today as the earliest send date.
    if (modes) modes.hidden = false;
    if (date) { var d = new Date(); date.min = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'id') showAmount();
      else if (t.name && t.name.indexOf('tt-ck-mode-') === 0) setMode(t.value === 'gift');
    });
    form.addEventListener('input', function () { showText(); hideError(); });
    if (message) {
      message.addEventListener('focus', function () { if (card && !reduce) card.classList.add('is-flipped'); });
      [name, mail, van].forEach(function (el) { if (el) el.addEventListener('focus', function () { if (card) card.classList.remove('is-flipped'); }); });
    }
    showAmount();
    setMode(true);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      hideError();
      var idEl = form.querySelector('input[name="id"]:checked');
      if (!idEl) { showError(root.getAttribute('data-ck-err-amount') || ''); return; }
      if (gift) {
        var m = mail.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(m)) { showError(root.getAttribute('data-ck-err-mail') || '', mail); return; }
      }
      var fd = new FormData(form);
      if (gift && van && van.value.trim()) {
        var base = (message.value || '').trim();
        var joined = (base ? base + '\n\n' : '') + (root.getAttribute('data-ck-from-prefix') || '') + ' ' + van.value.trim();
        fd.set('properties[Message]', joined.slice(0, message.maxLength));
      }
      busy = true; btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || '');
          window.location.assign(form.getAttribute('data-cart-url') || '/cart');
        })
        .catch(function (ex) {
          busy = false; btn.disabled = false; btn.removeAttribute('aria-busy');
          showError((root.getAttribute('data-ck-err-fail') || '') + (ex && ex.message ? ': ' + ex.message : '') + '. ' + (root.getAttribute('data-ck-err-retry') || ''));
        });
    });
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-tt-ck]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
